import { render, staticRenderFns } from "./appMenuConfig.vue?vue&type=template&id=bf540a36&scoped=true&"
import script from "./appMenuConfig.vue?vue&type=script&lang=js&"
export * from "./appMenuConfig.vue?vue&type=script&lang=js&"
import style0 from "./appMenuConfig.vue?vue&type=style&index=0&id=bf540a36&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf540a36",
  null
  
)

export default component.exports